module.exports = __webpack_public_path__ + "988fa4a0.svg";